import styled from "styled-components"
import { SectionWrapper} from "../WebsitePage/styles";
import {colors} from "../../const/colors";

export const SocialMediaSection = styled(SectionWrapper)`
  text-align: center;
  background: ${colors.lightBg}
`